import axios, { AxiosError } from "axios";
import { UserFriendlyError, ValidationError } from "./Api";
import { ErrorResponse, ValidationErrorResponse } from "./generated";

const checkIsErrorResponse = (data: any): data is ErrorResponse => {
  return data?.detail !== undefined;
};

const checkIsValidationErrorResponse = (
  data: any,
): data is ValidationErrorResponse => {
  return data?.detail !== undefined && Array.isArray(data.detail);
};

const USER_FRIENDLY_ERROR_STATUSES = [400, 404, 409];

const axiosInstance = axios.create();

let userId: string | undefined = undefined;
export const setActiveUserId = (type: string, id: string) => {
  userId = `${type}:${id}`;
};
export const clearActiveUserId = () => {
  userId = undefined;
};

// Send useful headers on requests to our API
axiosInstance.interceptors.request.use((config) => {
  if (userId !== undefined) {
    config.headers.set("fay-user-id", userId);
  }
  if (process.env.REACT_APP_FAY_UI_VERSION !== undefined) {
    config.headers.set(
      "fay-ui-version",
      "web:" + process.env.REACT_APP_FAY_UI_VERSION,
    );
  }
  return config;
});

// Add a 400 response interceptor to throw a UserFriendlyError
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error instanceof AxiosError &&
      !!error.response &&
      USER_FRIENDLY_ERROR_STATUSES.includes(error.response.status) &&
      checkIsErrorResponse(error.response.data)
    ) {
      throw new UserFriendlyError({
        response: error.response.data,
      });
    }
    throw error;
  },
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error instanceof AxiosError &&
      !!error.response &&
      error.response.status === 422 &&
      checkIsValidationErrorResponse(error.response.data)
    ) {
      throw new ValidationError({
        response: error.response.data,
      });
    }
    throw error;
  },
);

export default axiosInstance;
